import React, { useEffect, useState } from "react";
import AdminLayout from "./AdminLayout";
import "../Admin/admin.css";
import { endpoints } from "../_config";
import { get, post } from "../_services/apiService";
import { toast } from "react-toastify";

const SizeTypeDetails = () => {
    const [sizeTypeDetails, setSizeTypeDetails] = useState([]);
    const [serviceType, setServiceType] = useState([]);
    const [serviceSizeType, setServiceSizeType] = useState([]);
    const [editMode, setEditMode] = useState(false);

    const [formData, setFormData] = useState({
        id: 0,
        serviceTypeId: 0,
        sizeTypeId: 0,
        details: "",
        price:0,
        is_high_efficiency: "",
        isActive: true,
    });

    // ✅ Handle Input Change
    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: type === "checkbox" ? checked : value,
        }));
    };

    // ✅ Fetch all service types
    const getServiceType = async () => {
        try {
            const response = await get(endpoints.GetServiceTypeAll);
            if (response.isSuccess === 200) {
                setServiceType(response.data);
            } else {
                setServiceType([]);
            }
        } catch (error) {
            console.error("Error fetching service types:", error);
            setServiceType([]);
        }
    };

    // ✅ Fetch size types by selected service type
    const getServiceSizeType = async (serviceId) => {
        if (!serviceId) return;
        try {
            const response = await get(`${endpoints.GetSizeTypeByServiceId}/${serviceId}`);
            if (response.isSuccess === 200) {
                setServiceSizeType(response.data);
            } else {
                setServiceSizeType([]);
            }
        } catch (error) {
            setServiceSizeType([]);
        }
    };

    // ✅ Fetch all size type details
    const getSizeTypeDetails = async () => {
        try {
            const response = await get(endpoints.GetSizeDetailTypeAll);
            if (response.isSuccess === 200) {
                setSizeTypeDetails(response.data);
            } else {
                setSizeTypeDetails([]);
            }
        } catch (error) {
            setSizeTypeDetails([]);
        }
    };

    // ✅ Save / Update record
    const onSave = async (e) => {
        e.preventDefault();
        try {
            const response = await post(endpoints.SaveSizeTypeDetails, formData);
            if (response.isSuccess === 200) {
                toast.success("Saved successfully!");
                setFormData({
                    id: 0,
                    serviceTypeId: 0,
                    sizeTypeId: 0,
                    details: "",
                    price:"",
                    is_high_efficiency: "",
                    isActive: true,
                });
                getSizeTypeDetails();
                document.getElementById("closeModalBtn").click();
            } else {
                toast.error(response.message || "Failed to save");
            }
        } catch (error) {
            toast.error("Something went wrong.");
        }
    };

    // ✅ Edit
    const handleEdit = (item) => {
        setEditMode(true);
        setFormData({
            id: item.id,
            serviceTypeId: item.servicetype,
            sizeTypeId: item.sizeTypeId,
            details: item.details,
            price:item?.price,
            is_high_efficiency: item?.is_high_efficiency,
            isActive: item.isActive,
        });
        getServiceSizeType(item.servicetype);
        const modal = new window.bootstrap.Modal(document.getElementById("modeldata"));
        modal.show();
    };

    // ✅ Delete
    const handleDelete = async (id) => {
        if (window.confirm("Are you sure you want to delete this record?")) {
            try {
                const response = await get(`${endpoints.DeleteSizeTypeDetailById}?detail_id=${id}`);
                if (response.isSuccess === 200) {
                    toast.success("Deleted successfully!");
                    getSizeTypeDetails();
                } else {
                    toast.error("Failed to delete.");
                }
            } catch (error) {
                toast.error("Error while deleting.");
            }
        }
    };

    // 🔁 Auto fetch data
    useEffect(() => {
        getServiceType();
        getSizeTypeDetails();
    }, []);

    return (
        <AdminLayout>
            <div className="product_wepper">
                <div className="container-fluid">
                    <div className="row justify-content-end">
                        <div className="col-lg-7">
                            <div className="row align-items-center justify-content-end">
                                <div className="col-lg-5 col-md-6 col-sm-6 add_subcategory">
                                    <button
                                        type="button"
                                        className="all_sumbit_button"
                                        data-bs-toggle="modal"
                                        data-bs-target="#modeldata"
                                        onClick={() => {
                                            setEditMode(false);
                                            setFormData({
                                                id: 0,
                                                serviceTypeId: 0,
                                                sizeTypeId: 0,
                                                details: "",
                                                price:0,
                                                is_high_efficiency: "",
                                                isActive: true,
                                            });
                                            setServiceSizeType([]);
                                        }}
                                    >
                                        + Add Size Type Detail
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Table */}
                    <div className="mt-3 product_hedding_table_main" style={{ overflowX: "auto" }}>
                        <table className="table table-bordered">
                            <thead>
                                <tr>
                                    <th>S.No</th>
                                    <th>Details</th>
                                    <th>Service Name</th>
                                    <th style={{ minWidth: "150px" }}>Size Type Name</th>
                                    <th style={{ minWidth: "120px" }}>Price</th>
                                    <th style={{ minWidth: "120px" }}>High Efficiency</th>
                                    <th>Active</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {sizeTypeDetails.length > 0 ? (
                                    sizeTypeDetails.map((item, index) => (
                                        <tr key={item.id}>
                                            <td>{index + 1}</td>
                                            <td>{item.details}</td>
                                            <td>{item.serviceName}</td>
                                            <td>{item.typeName}</td>
                                            <td>{item.price}</td>
                                            <td>{(item.is_high_efficiency === 0 || item.is_high_efficiency === "0") ? "No" : (item.is_high_efficiency === 1 || item.is_high_efficiency === "1") ? "Yes" : "N/A"}</td>
                                            <td>{item.isActive ? "Yes" : "No"}</td>
                                            <td>
                                                <div className="action_btn_weepr">
                                                    <span className="edit_icon_wepper" onClick={() => handleEdit(item)}>
                                                        <svg id="Layer_1" viewBox="0 0 512 512" width="15" height="15" xmlns="http://www.w3.org/2000/svg">
                                                            <g transform="matrix(1,0,0,1,0,0)">
                                                                <path
                                                                    d="m41.3 512c-22.8 0-41.3-18.5-41.3-41.3 0-2.6.2-5.2.7-7.7l27.3-144.8c1.5-8.2 5.5-15.7 11.4-21.5l274-274c14.7-14.7 35.1-22.7 57.7-22.7 8.1 0 16.1 1 24 2.8 25.5 5.9 51.1 20.7 72.2 41.8s36 46.7 41.8 72.2c7.4 31.9.2 61.7-19.8 81.7l-274 274c-5.9 5.9-13.4 9.8-21.5 11.4l-144.8 27.4c-2.5.5-5.1.7-7.7.7zm51.8-93.1 72.9-13.8 182-182-59.1-59.1-182 182zm313.3-254.2 23.1-23.1c.2-5.4-3.8-21.8-20.6-38.5-10.1-10.2-22-17.4-32.4-19.8-1.8-.4-3.7-.7-5.5-.7h-.7l-23 23z"
                                                                    fill="#000"
                                                                ></path>
                                                                <path
                                                                    d="m499.4 119.1c-5.4-23.7-19.4-47.6-39.1-67.4s-43.8-33.7-67.4-39.1c-28.5-6.6-54.9-.4-72.3 17.1l-274 274c-4.5 4.4-7.5 10.1-8.7 16.3l-27.4 144.9c-3.2 17 8 33.4 24.9 36.6 1.9.4 3.9.5 5.8.5s3.9-.2 5.8-.5l145-27.4c6.2-1.2 11.9-4.2 16.3-8.6l274-274c17.5-17.5 23.7-43.9 17.1-72.4zm-328.5 295.3-90.3 17 17-90.3 191.3-191.3 73.3 73.3zm267.2-267.2-31.7 31.7-73.2-73.3 31.7-31.7c1-1 5.6-2.3 14-.4 12.2 2.8 25.8 11 37.2 22.4 23.5 23.7 25.6 47.7 22 51.3z"
                                                                    fill="url(#gradient1)"
                                                                ></path>
                                                                <defs>
                                                                    <linearGradient id="gradient1" x1="0%" y1="0%" x2="100%" y2="100%">
                                                                        <stop offset="0%" stop-color="#000"></stop>
                                                                        <stop offset="100%" stop-color="#000"></stop>
                                                                    </linearGradient>
                                                                </defs>
                                                            </g>
                                                        </svg>
                                                    </span>
                                                    <span className="delete_icon_weepr" onClick={() => handleDelete(item.id)}>
                                                        <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="15" height="15" viewBox="0 0 24 24">
                                                            <path
                                                                d="M 10 2 L 9 3 L 4 3 L 4 5 L 5 5 L 5 20 C 5 20.522222 5.1913289 21.05461 5.5683594 21.431641 C 5.9453899 21.808671 6.4777778 22 7 22 L 17 22 C 17.522222 22 18.05461 21.808671 18.431641 21.431641 C 18.808671 21.05461 19 20.522222 19 20 L 19 5 L 20 5 L 20 3 L 15 3 L 14 2 L 10 2 z M 7 5 L 17 5 L 17 20 L 7 20 L 7 5 z M 9 7 L 9 18 L 11 18 L 11 7 L 9 7 z M 13 7 L 13 18 L 15 18 L 15 7 L 13 7 z"
                                                                fill="#FF0000"
                                                            ></path>
                                                        </svg>
                                                    </span>
                                                </div>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="6" className="text-center">
                                            No records found.
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            {/* Modal */}
            <div
                className="modal fade"
                id="modeldata"
                tabIndex="-1"
                aria-labelledby="exampleModalLabel"
                aria-hidden="true"
            >
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">
                                {editMode ? "Edit Size Type Detail" : "Add Size Type Detail"}
                            </h5>
                            <button
                                type="button"
                                id="closeModalBtn"
                                className="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            ></button>
                        </div>

                        <form onSubmit={onSave}>
                            <div className="modal-body">
                                {/* Service Type */}
                                <div className="mb-3">
                                    <label className="form-label">Service Type</label>
                                    <select
                                        name="serviceTypeId"
                                        className="form-control"
                                        value={formData.serviceTypeId}
                                        onChange={(e) => {
                                            handleChange(e);
                                            getServiceSizeType(e.target.value);
                                        }}
                                        required
                                    >
                                        <option value="0">Select Service Type</option>
                                        {serviceType.map((s) => (
                                            <option key={s.serviceId} value={s.serviceId}>
                                                {s.serviceName}
                                            </option>
                                        ))}
                                    </select>
                                </div>

                                {/* Size Type */}
                                <div className="mb-3">
                                    <label className="form-label">Size Type</label>
                                    <select
                                        name="sizeTypeId"
                                        className="form-control"
                                        value={formData.sizeTypeId}
                                        onChange={handleChange}
                                        required
                                    >
                                        <option value="0">Select Size Type</option>
                                        {serviceSizeType.map((t) => (
                                            <option key={t.sizeTypeId} value={t.sizeTypeId}>
                                                {t.typeName}
                                            </option>
                                        ))}
                                    </select>
                                </div>

                                {/* Details */}
                                <div className="mb-3">
                                    <label className="form-label">Details</label>
                                    <textarea
                                        type="text"
                                        name="details"
                                        value={formData.details}
                                        onChange={handleChange}
                                        className="form-control"
                                        placeholder="Enter details"
                                        required
                                        style={{minHeight:"100px"}}
                                    />
                                </div>

                                <div className="mb-3">
                                    <label className="form-label">Price</label>
                                    <input
                                        type="text"
                                        name="price"
                                        value={formData.price}
                                        onChange={handleChange}
                                        className="form-control"
                                        placeholder="Enter price"
                                        required
                                    />
                                </div>

                                <div className="mb-3">
                                    <label className="form-label d-block">High Efficiency</label>

                                    <div className="form-check form-check-inline">
                                        <input
                                            className="form-check-input"
                                            type="radio"
                                            name="is_high_efficiency"
                                            id="highEfficiencyYes"
                                            value="1"
                                            checked={String(formData.is_high_efficiency) === "1"}
                                            onChange={handleChange}
                                            required
                                        />
                                        <label className="form-check-label" htmlFor="highEfficiencyYes">
                                            Yes
                                        </label>
                                    </div>

                                    <div className="form-check form-check-inline">
                                        <input
                                            className="form-check-input"
                                            type="radio"
                                            name="is_high_efficiency"
                                            id="highEfficiencyNo"
                                            value="0"
                                            checked={String(formData.is_high_efficiency) === "0"}
                                            onChange={handleChange}
                                        />
                                        <label className="form-check-label" htmlFor="highEfficiencyNo">
                                            No
                                        </label>
                                    </div>

                                    <div className="form-check form-check-inline">
                                        <input
                                            className="form-check-input"
                                            type="radio"
                                            name="is_high_efficiency"
                                            id="highEfficiencyNA"
                                            value="2"
                                            checked={String(formData.is_high_efficiency) === "2"}
                                            onChange={handleChange}
                                        />
                                        <label className="form-check-label" htmlFor="highEfficiencyNA">
                                            N/A
                                        </label>
                                    </div>
                                </div>

                                {/* Active */}
                                <div className="form-check">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        name="isActive"
                                        checked={formData.isActive}
                                        onChange={handleChange}
                                        id="isActive"
                                    />
                                    <label className="form-check-label" htmlFor="isActive">
                                        Active
                                    </label>
                                </div>
                            </div>

                            <div className="modal-footer">
                                <button type="submit" className="all_sumbit_button">
                                    {editMode ? "Update" : "Save"}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </AdminLayout>
    );
};

export default SizeTypeDetails;